import { render } from "./FeaturedProductsComponent.vue?vue&type=template&id=b0ab5714&scoped=true"
import script from "./FeaturedProductsComponent.vue?vue&type=script&lang=js"
export * from "./FeaturedProductsComponent.vue?vue&type=script&lang=js"

import "./FeaturedProductsComponent.vue?vue&type=style&index=0&id=b0ab5714&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0ab5714"]])

export default __exports__